export function adminAuthHeaders(token) {
  const t = String(token || '').trim();
  return {
    'Content-Type': 'application/json',
    'X-Admin-Session': t,
    Authorization: `Bearer ${t}`,
  };
}

export function orderPaymentBadge(order) {
  const status = String(order?.status || '').toLowerCase();
  const type = order?.payment_type;
  if (
    type === 'paid' ||
    order?.paid_at ||
    ['paid', 'processing', 'shipped', 'completed'].includes(status)
  ) {
    return { label: 'Paid', className: 'bg-success' };
  }
  if (
    type === 'razorpay_pending' ||
    (status === 'pending' && (order?.razorpay_order_id || type === 'razorpay_pending'))
  ) {
    return { label: 'Awaiting payment', className: 'bg-warning text-dark' };
  }
  if (
    type === 'offline' ||
    (order?.status === 'pending' && !order?.razorpay_order_id && order?.stock_allocated)
  ) {
    return { label: 'Offline · stock held', className: 'bg-secondary' };
  }
  return { label: 'Pending', className: 'bg-secondary' };
}

export function productStockBucket(p) {
  const sq = p?.stock_qty;
  if (sq === null || sq === undefined) return 'unlimited';
  const n = Number(sq);
  if (!Number.isFinite(n) || n <= 0) return 'out';
  if (n <= 3) return 'low';
  return 'ok';
}

export function countStockFromProducts(sortedCategories, editableProducts) {
  let out = 0;
  let low = 0;
  let tracked = 0;
  sortedCategories.forEach((c) => {
    (editableProducts[c.slug] || []).forEach((p) => {
      const bucket = productStockBucket(p);
      if (bucket === 'unlimited') return;
      tracked += 1;
      if (bucket === 'out') out += 1;
      else if (bucket === 'low') low += 1;
    });
  });
  return { out, low, tracked };
}
